import { Overlays } from "./overlays";

import {xCore} from './core';
import { URN as NSURN } from './utils/urn';
import {NSObjDetails} from './obj_details';
import { NSFunctions } from './utils/functions';
import { NSGeoJson } from './utils/geojson'

import { Map as Module_Map } from './map';
import GeoJSON from 'ol/format/GeoJSON';
import MVT from 'ol/format/MVT';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import { Fill, Icon, Stroke, Style, Text, Circle as CircleStyle, RegularShape } from 'ol/style';
import {unByKey} from 'ol/Observable';
import { NSObjectMultipleSelect } from "./obj_multiple_select";


export let OverlaysVT = {};

let o_struct_overlays;

OverlaysVT.init = function (o_struct_overlays_in) {
    
    o_struct_overlays = o_struct_overlays_in;
}




// Style:
//----------------------------------------------------------------------
var image = new CircleStyle({
    radius: 5,
    //fill: null, -> will affect select event!!!!!!
    fill: new Fill({ color: 'rgba(255,255,255,0.0)' }),
    stroke: new Stroke({color: 'red', width: 2}),
  });
  
  var image_2 = new CircleStyle({
    radius: 10,
    //fill: null, -> will affect select event!!!!!!
    fill: new Fill({ color: 'rgba(255,255,255,0.0)' }),
    stroke: new Stroke({color: 'orange', width: 7}),
  });
  
  var image_3 = new CircleStyle({
    radius: 30,
    //fill: null, -> will affect select event!!!!!!
    fill: new Fill({ color: 'rgba(255,255,255,0.0)' }),
    stroke: new Stroke({color: 'blue', width: 10}),
  });
  
  
  var style_simple = new Style({
    image: image,
    fill: new Fill({
      color: '#ADD8E6'
    }),
    stroke: new Stroke({
      color: '#880000',
      width: 1
    })
  });
  
  var style_simple_castanheiro = new Style({
    image: image_2,
    fill: new Fill({
      color: '#ADD8E6'
    }),
    stroke: new Stroke({
      color: '#880000',
      width: 1
    })
  });
  
  var style_simple_selected = new Style({
      image: image_3,
      fill: new Fill({
          color: NSFunctions.f_hex_to_rgb('#FF0000', 0.5) //'#ADD8E6''
      }),
      stroke: new Stroke({
          color: '#FF0000', //'#880000',
          width: 4
      })
  });
  //----------------------------------------------------------------------
  
  var f_get_simple_style = function(feature)
  {
      return f_get_base_simple_style(feature);
  }
  
  var f_get_base_simple_style = function(feature)
  {
    if(feature.properties_.especie == "castanheiro da india")
      return style_simple_castanheiro;
    else
      return style_simple;
  }


  let f_get_style_selected = function (feature, tree_node) {

      let icon_displacement;
      if(feature.custom_extra_info && feature.custom_extra_info.b_is_icon)
      {
          let i_icon_height = feature.custom_extra_info.icon_size[1];
          //icon_displacement = feature.custom_extra_info.icon_displacement;
          icon_displacement = [0, (i_icon_height/2)];
      }
      
      

      let image = new CircleStyle({
          radius: 30,
          //fill: null, -> will affect select event!!!!!!
          fill: new Fill({ color: 'rgba(255,255,255,0.0)' }),
          stroke: new Stroke({color: '#FF0000', width: 10}),
          displacement: icon_displacement
      
      });
      
      let style_selected = new Style({
          image: image,
          fill: new Fill({
              color: NSFunctions.f_hex_to_rgb('#FF0000', 0.5) //'#ADD8E6''
          }),
          stroke: new Stroke({
              color: '#FF0000', //'#880000',
              width: 4
          })
      });

      return style_selected;

  }

  var f_get_function_get_style = function(tree_node)
  {

    let s_table_name = NSURN.f_get_urn_table_name(tree_node.urn)

    /*
      ex:
        style: {
          fillColor: "#99FF99"
          fillOpacity: 0.8
          strokeColor: "#00FF00"
          strokeOpacity: 0.9
          strokeWeight: 4
        }

    */

    let f_get_style_local = function(feature)
    {

      return f_get_style(feature, tree_node);
      
    };

    return f_get_style_local;
    
  }
  

  let f_get_style = function (feature, tree_node) {

    let s_stroke_color = tree_node.style.strokeColor;
    let s_stroke_weight = tree_node.style.strokeWeight;
    let s_icon = tree_node.icon;
    let s_geom_type_lc = feature.getGeometry().getType().toLowerCase();
    let b_is_icon = (s_icon && s_geom_type_lc == 'point')? true : false;

    //console.log("aquiiiiiii - 01 - tree_node.urn=" + tree_node.urn);
    if (tree_node.urn == 'urn__SEP__table__SEP__municipio__SEP__arvore') {
        //console.log("aquiiiiiii");
        //console.log(feature.getProperties().nome_cientifico);
        //console.log(tree_node);
        //console.log(feature);
        //window.feature_ = feature;
        
        if (feature.getProperties().nome_cientifico == "Washingtonia filifera") {
            s_stroke_color = "#009900";
        }
        else if (feature.getProperties().nome_cientifico == "Cercis siliquastrum") {
            s_stroke_color = "#007700";
        }
        else if (feature.getProperties().nome_cientifico == "Persea americana") {
            s_stroke_color = "#005500";
        } else if (feature.getProperties().nome_cientifico == "Phoenix canariensis") {
            s_stroke_color = "#004400";
        }


    }

    let o_fill = new Fill({ color: 'rgba(255,255,255,0.0)' });
    let o_stroke = new Stroke({ color: s_stroke_color, width: s_stroke_weight });

    let image_style;
    //let i_icon_size;

    if(b_is_icon)
    {
        /*
            new Icon({
                anchor: [0.5, 46],
                anchorXUnits: 'fraction',
                anchorYUnits: 'pixels',
                src: 'data/icon.png',
            })
        */
        let s_icon_url = xCore.application.layer_images_base_path + "/" + s_icon;
        //console.log('s_icon_url: ' + s_icon_url);
        image_style = new Icon({
            anchor: [0.5, 1.0],
            anchorXUnits: 'fraction',
            anchorYUnits: 'fraction',
            src: s_icon_url,
        })

        //window.icon_ = image_style;
        //window.size_ = image_style.getSize();
        //console.log("aquiiiiiiiiiiiiiiiiiii size_: "+ size_);
        //i_icon_height = image_style.getSize()[1];
        //console.log("aquiiiiiiiiiiiiiiiiiii i_icon_height: "+ i_icon_height);

    }
    else if (tree_node.urn == 'urn__SEP__table__SEP__municipio__SEP__arvore') {
        /*
          "Junta de Freguesia"

          "Não é municipal"
          "Loteador"
          "EMAC"
          "Outros"
          "CMC Outros"
          "Cascais Envolvente"
          "CMC"
          "DGEV CEVAR"
          "Cascais Ambiente"
          "DGEV" 
        */

        let a_group_1 = ["EMAC", "DGEV CEVAR", "DGEV"];
        let a_group_2 = ["Não é municipal", "Loteador", "Outros"];
        let s_shape_selector_value = feature.getProperties().gestor;
        if (a_group_1.indexOf(s_shape_selector_value) > -1) {
            //square
            image_style = new RegularShape({
                fill: o_fill,
                stroke: o_stroke,
                points: 4,
                radius: 10,
                angle: Math.PI / 4,
            });

        }
        else if (a_group_1.indexOf(s_shape_selector_value) > -1) {
            //rectangle
            image_style = new RegularShape({
                fill: o_fill,
                stroke: o_stroke,
                points: 4,
                radius: 10,
                angle: Math.PI / 4,
            });

        }
        else {
            //circle
            image_style = new CircleStyle({
                radius: 20,
                //fill: null, -> will affect select event!!!!!!
                fill: o_fill,
                stroke: o_stroke,
            });
        }


    }
    else {
        image_style = new CircleStyle({
            radius: 25,
            //fill: null, -> will affect select event!!!!!!
            fill: o_fill,
            stroke: o_stroke,
        });
    }



    var o_style = new Style({
        image: image_style
        /*,
        fill: new Fill({
          color: '#ADD8E6'
        }),
        stroke: new Stroke({
          color: '#880000',
          width: 1
        })
        */
        ,fill: o_fill,
        stroke: o_stroke
    });

    if(b_is_icon)
    {
        let icon_size = image_style.getSize();
        let icon_displacement = image_style.getDisplacement();
        
        feature.custom_extra_info = {};
        feature.custom_extra_info.b_is_icon = b_is_icon;
        feature.custom_extra_info.icon_size = icon_size;
        feature.custom_extra_info.icon_displacement = icon_displacement;
    }


    return o_style;
}
  //----------------------------------------------------------------------


  /*

  */
  OverlaysVT.f_add_vector_tiles_layer = function (tree_node) {
     

    let a_urn_info = NSURN.f_get_urn_info(tree_node.urn);
    let s_urn_table = a_urn_info[2];
    
    let b_decluter = ( tree_node.vector_tiles_simplify_data_on_map == true ) ? true : false;
    let s_geoserver_layer_name = ( tree_node.geo_server_layer_name != null &&  tree_node.geo_server_layer_name.length > 0 ) ? tree_node.geo_server_layer_name : s_urn_table;

    let s_vt_url =  xCore.application.endpoints.ogc + '/gwc/service/wmts?' 
      +'REQUEST=GetTile&SERVICE=WMTS&VERSION=1.0.0&LAYER=GeoCascais:'+ s_geoserver_layer_name + '&STYLE='
      +'&TILEMATRIX=EPSG:900913:{z}'
      +'&TILEMATRIXSET=EPSG:900913&FORMAT=application/vnd.mapbox-vector-tile'
      +'&TileCol={x}&TileRow={y}';


    let o_vtl = new VectorTileLayer({
      declutter: b_decluter,
      source: new VectorTileSource({
        /*
        attributions:
          '© <a href="https://www.mapbox.com/map-feedback/">testando...</a> ' +
          '© <a href="https://www.openstreetmap.org/copyright">' +
          'testando.... contributors</a>',
          */
        format: new MVT(),
      
          url: s_vt_url
            
      }),
    
      //style: createMapboxStreetsV6Style(Style, Fill, Stroke, Icon, Text), // https://openlayers.org/en/v6.6.0/examples/resources/mapbox-streets-v6-style.js
      //style: style_simple ,
      //style: f_get_simple_style
      style: f_get_function_get_style(tree_node)
    
    });


    let overlay_vt = new Overlays.objs.OverlayVT({tree_node: tree_node});
    overlay_vt.o_vtl = o_vtl;
    //window.o_vtl_ = o_vtl;

    o_struct_overlays.f_add_vt_overlay(overlay_vt);

    var map = Module_Map.f_get_map();
    map.addLayer(o_vtl);

    f_add_vector_tiles_layer_click_event(overlay_vt);

  }

  OverlaysVT.f_remove_vector_tiles_layer = function(tree_node)
  {
    console.log("overlays.js -  OverlaysVT.f_remove_vector_tiles_layer")
    
    let overlay = o_struct_overlays.f_get_vt_overlay(tree_node.id);
    let map = Module_Map.f_get_map();

    //console.log(overlay.o_vtl);
//    console.log(overlay.o_vtl_selection);
    
    map.removeLayer(overlay.o_vtl);
//    map.removeLayer(overlay.o_vtl_selection);
    
    unByKey(overlay.map_click_listner_key);

    o_struct_overlays.f_remove_vt_overlay(tree_node.id);

  }

  //-----------------------------------------------------------------------------
  //-- click event:
  
  //    overlay_vt -> Overlays.objs.OverlayVT
  var f_add_vector_tiles_layer_click_event = function (overlay_vt) {

    let o_vtl = overlay_vt.o_vtl;

    var map = Module_Map.f_get_map();

    let o_selection = {};
    /*
    // Selection
    const o_vtl_selection = new VectorTileLayer({
        // map: map,
        renderMode: 'vector',
        source: o_vtl.getSource(),
        style: function (feature) {
            if (feature.getId() in o_selection) {

            //return style_simple_selected;
            return f_get_style_selected(feature, overlay_vt.tree_node);
            }
            //else feature is not visible
        },
        });

    overlay_vt.o_vtl_selection = o_vtl_selection;
    map.addLayer(o_vtl_selection);
    */
    
    
    //****HERE SELECT TYPE:
    let s_select_type = 'singleselect'; // 'multiselect' 'singleselect-hover'
    
    /*
    map events: click, pointermove, ...
    */
    let map_click_listner_key =
    map.on(['click', 'pointermove'], function (event) {
        if(NSObjectMultipleSelect.f_is_active()) return;
        if (
        (event.type !== 'click') 
        ) {
        return;
        }
        o_vtl.getFeatures(event.pixel).then(function (features) {
        if (!features.length) {
            o_selection = {};
//            o_vtl_selection.changed();
            return;
        }
        const feature = features[0];
        if (!feature) {
            return;
        }
        const fid = feature.getId();
        console.log("overlays_vt - click");
        console.log(feature);
    
        if (s_select_type.indexOf('singleselect') === 0) {
            o_selection = {};
        }
        // add selected feature to lookup
        o_selection[fid] = feature;
    
//        o_vtl_selection.changed();


        
        //window.feature_ = feature;

        //Show Details:

        let s_record_id = feature.getId();
        let s_table_urn = overlay_vt.tree_node.urn;
        let s_record_urn = NSURN.f_create_record_urn_from_table_urn(s_table_urn, s_record_id);
        let s_geometry_internal_name = overlay_vt.tree_node.geometry_urn;
        /*
        let o_geo_json = {

          id: s_record_urn,
          properties: feature.getProperties(),

          //AQUIIII TODO TO DO NAO SEI SE OS CAMPOS ABAIXO SAO COMPATIVEIS COM GEOJSON, SOBRETUDO PARA GEOMETRIAS Q N SEJAM PONTOS
          bbox: feature.getExtent(),
          geometry:
          {
            coordinates: feature.getFlatCoordinates(),
            type: feature.getType()
          }
          
        };
        */
        window.GeoJSON_ = GeoJSON;
        window.feature_ = feature;

        /*
        //shallow copy
				let feature_updated = Object.assign({}, feature_);
        Object.setPrototypeOf( feature_updated, Object.getPrototypeOf(feature_) );
        //updating to use of GeoJSON().writeFeatureObject -> NÃO FUNCIONA!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
				feature_updated.hasProperties = function(){return Object.keys(feature_updated.getProperties()).length > 0;}
        window.feature_updated_ = feature_updated;

        let o_geo_json = new GeoJSON().writeFeatureObject(feature_updated, {rightHanded: true});
        */

        let o_geo_json = NSGeoJson.f_get_geojson_feature_from_openlayers_render_feature(feature);
        o_geo_json.id = s_record_urn;
        o_geo_json.geometry_name = s_geometry_internal_name;
        o_geo_json.properties = feature.getProperties();

        window.o_geo_json_ = o_geo_json;

        let b_is_icon = (feature.custom_extra_info && feature.custom_extra_info.b_is_icon) ? true: false;
        let a_icon_size_xy;
        if(b_is_icon)
        {
          a_icon_size_xy = feature.custom_extra_info.icon_size
        }
        
        console.log('s_record_urn: '+ s_record_urn);
        let b_clean_join_list = true;
        let o_in = {
            tree_node_id: overlay_vt.tree_node_id,
            s_urn: s_record_urn,
            b_clean_join_list: b_clean_join_list,
            o_ll: event.coordinate,
            s_geometry_internal_name: s_geometry_internal_name,
            o_geo_json: o_geo_json,
            b_is_icon: b_is_icon,
            a_icon_size_xy: a_icon_size_xy,
        }

        NSObjDetails.f_open_details_by_feature(o_in);



        });
    });
    
    overlay_vt.map_click_listner_key = map_click_listner_key;
    


  }
  